import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import CreatableSelect from 'react-select/creatable';
import Sidebar from './Sidebar';
import '../css/SubmitMission.css';
import API_BASE_URL from '../api';
const initialSkillsOptions = [
  { value: 'java', label: 'Java' },
  { value: 'python', label: 'Python' },
  { value: 'php', label: 'PHP' },
  // Add more skill options as needed
];

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const ViewMission = () => {
  const { id } = useParams();
  const [mission, setMission] = useState({
    name: '',
    description: '',
    skills: [],
    reference: '',
    createdAt: '',
    status: 'draft',
    experience: '',
    location: '',
    telecommute: '',
    startDate: '',
    asap: false,
    budgetTJM: 450,
    assignedUserId: '',
    assignedUserName: '',
    assignedUserTitle: '',
    assignedUserPhoto: '',
  });
  const [editMode, setEditMode] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchMission = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const response = await axios.get(`${API_BASE_URL}/api/missions/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        const missionData = response.data;

        // Fetching user details for assignedUser
        const userResponse = await axios.get(`${API_BASE_URL}/api/users/${missionData.assignedUserId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        const userData = userResponse.data;
        setMission({
          ...missionData,
          startDate: formatDate(missionData.startDate),
          assignedUserName: `${userData.firstName} ${userData.lastName}`,
          assignedUserTitle: userData.title,
          assignedUserPhoto: userData.photo
        });
      } catch (error) {
        console.error('Fetch Mission Error:', error);
        setError('Erreur lors de la récupération du besoin');
      }
    };

    fetchMission();
  }, [id]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleDelete = async () => {
    const token = localStorage.getItem('authToken');
    try {
      await axios.delete(`${API_BASE_URL}/api/missions/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setIsConfirmationOpen(false);
      navigate('/missions');
    } catch (error) {
      console.error('Delete Mission Error:', error);
      setError('Erreur lors de la suppression du besoin');
      setIsConfirmationOpen(false);
    }
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
  };

  const handleSave = async () => {
    const token = localStorage.getItem('authToken');
    try {
      await axios.patch(`${API_BASE_URL}/api/missions/${id}`, mission, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setEditMode(false);
      setSuccessMessage('besoin à jour avec succès');
    } catch (error) {
      console.error('Update besoin Error:', error);
      setError('Erreur lors de la mise à jour du besoin');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setMission({
      ...mission,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleDescriptionChange = (newContent) => {
    setMission({
      ...mission,
      description: newContent
    });
  };

  const handleSkillsChange = (selectedOptions) => {
    setMission({
      ...mission,
      skills: selectedOptions.map(option => option.value)
    });
  };

  const handleCreateSkill = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setMission({
      ...mission,
      skills: [...mission.skills, inputValue]
    });
  };

  const handleCancel = () => {
    setEditMode(false);
    setSuccessMessage('');
  };

  const openConfirmation = () => {
    setIsConfirmationOpen(true);
  };

  const closeConfirmation = () => {
    setIsConfirmationOpen(false);
  };


  const handlePublish = async () => {
    const token = localStorage.getItem('authToken');
    try {
      await axios.patch(`${API_BASE_URL}/api/missions/${id}`, { status: 'published' }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setMission({ ...mission, status: 'published' });
      setSuccessMessage('besoin publié avec succès');
    } catch (error) {
      console.error('Publish Mission Error:', error);
      setError('Erreur lors de la publication du besoin');
    }
  };

  const handleUnpublish = async () => {
    const token = localStorage.getItem('authToken');
    try {
      await axios.patch(`${API_BASE_URL}/api/missions/${id}`, { status: 'draft' }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setMission({ ...mission, status: 'draft' });
      setSuccessMessage('Mission mise hors ligne avec succès');
    } catch (error) {
      console.error('Unpublish Mission Error:', error);
      setError('Erreur lors de la mise hors ligne du besoin');
    }
  };

  if (error) {
    return <div className="alert alert-danger mt-3">{error}</div>;
  }

  if (!mission) {
    return <div className="spinner"></div>; // Utilisation du spinner au lieu d'un simple texte
  }

  const isOwner = mission.assignedUserId === userId;

  return (
    <div className="submit-mission-container">
      <Sidebar />
      <div className="main-content">
        {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
        {error && <div className="alert alert-danger mt-3">{error}</div>}
        <div className="mission-container">
          <div className="mission-header">
            <h2>{editMode ? 'Modifier la mission' : 'Détails de la mission'}</h2>
            {isOwner && (
              <>
                {mission.status === 'draft' ? (
                  <button className="publish-button" onClick={handlePublish} disabled={mission.status === 'published'}>
                    Publier
                  </button>
                ) : (
                  <button className="unpublish-button" onClick={handleUnpublish}>
                    Mettre hors ligne
                  </button>
                )}
              </>
            )}
          </div>
          <form className="submit-mission-form">
            <div className="form-group">
              <label htmlFor="name">Titre de l’offre</label>
              <input
                type="text"
                id="name"
                name="name"
                value={mission.name}
                onChange={handleChange}
                readOnly={!editMode}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="reference">Votre référence</label>
              <input
                type="text"
                id="reference"
                name="reference"
                value={mission.reference}
                readOnly
              />
            </div>
            <div className="form-group">
              <label htmlFor="experience">Expérience</label>
              <select
                id="experience"
                name="experience"
                value={mission.experience}
                onChange={handleChange}
                disabled={!editMode}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Moins de 2 ans d'expérience">Moins de 2 ans d'expérience</option>
                <option value="2 à 5 ans d'expérience">2 à 5 ans d'expérience</option>
                <option value="5 à 10 ans d'expérience">5 à 10 ans d'expérience</option>
                <option value="Plus de 10 ans d'expérience">Plus de 10 ans d'expérience</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="location">Lieu d'exécution</label>
              <input
                type="text"
                id="location"
                name="location"
                value={mission.location}
                onChange={handleChange}
                readOnly={!editMode}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="telecommute">Télétravail</label>
              <select
                id="telecommute"
                name="telecommute"
                value={mission.telecommute}
                onChange={handleChange}
                disabled={!editMode}
                required
              >
                <option value="">Sélectionner...</option>
                <option value="Possible">Possible</option>
                <option value="Non">Non</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="skills">Compétences attendues</label>
              <CreatableSelect
                id="skills"
                name="skills"
                isMulti
                options={initialSkillsOptions}
                onChange={handleSkillsChange}
                onCreateOption={handleCreateSkill}
                value={initialSkillsOptions.filter(option => mission.skills.includes(option.value))}
                placeholder="Rechercher une compétence..."
                isDisabled={!editMode}
              />
            </div>
            <div className="form-group">
              <label htmlFor="startDate">Date de début</label>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={mission.startDate || ''}
                onChange={handleChange}
                readOnly={!editMode}
                disabled={mission.asap}
                required={!mission.asap}
              />
            </div>
            <div className="form-group asap-checkbox">
              <label htmlFor="asap">ASAP</label>
              <input
                type="checkbox"
                id="asap"
                name="asap"
                checked={mission.asap}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="budgetTJM">Budget TJM</label>
              <div className="budget-slider">
                <input
                  type="range"
                  id="budgetTJM"
                  name="budgetTJM"
                  min="100"
                  max="1800"
                  value={mission.budgetTJM}
                  onChange={handleChange}
                  disabled={!editMode}
                  required
                />
                <span>{`${mission.budgetTJM}€`}</span>
              </div>
            </div>

            <div className="form-group full-width">
              <label htmlFor="description">Description du poste</label>
              {editMode ? (
                <JoditEditor
                  value={mission.description}
                  onChange={handleDescriptionChange}
                />
              ) : (
                <div dangerouslySetInnerHTML={{ __html: mission.description }} />
              )}
            </div>
            {editMode && (
              <div className="form-actions">
                <button
                  type="button"
                  className="save-button"
                  onClick={handleSave}
                >
                  Sauvegarder
                </button>
                <button
                  type="button"
                  className="publish-button"
                  onClick={handleCancel}
                >
                  Annuler
                </button>
              </div>
            )}
          </form>
          {!editMode && isOwner && (
            <div className="form-actions">
              <button
                type="button"
                className="publish-button"
                onClick={handleEditToggle}
              >
                Modifier
              </button>
              <button
                type="button"
                className="delete-button"
                onClick={openConfirmation}
              >
                Supprimer
              </button>
              <button
                type="button"
                className="back-button"
                onClick={() => navigate('/missions')}
              >
                Retour
              </button>
            </div>
          )}
          {isConfirmationOpen && (
            <div className="confirmation-modal">
              <div className="confirmation-content">
                <h2>Confirmation de la suppression</h2>
                <p>Êtes-vous sûr de vouloir supprimer cette mission ?</p>
                <div className="confirmation-buttons">
                  <button className="confirm-button" onClick={handleDelete}>Oui</button>
                  <button className="cancel-button" onClick={closeConfirmation}>Non</button>
                </div>
              </div>
            </div>
          )}
        </div>
        {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
        {error && <div className="alert alert-danger mt-3">{error}</div>}

        {/* Section for published by information */}
        <div className="published-by">
          <h3>Publié par</h3>
          <div className="publisher-info">
            <img src={mission.assignedUserPhoto} alt={mission.assignedUserName} className="publisher-photo" />
            <div>
              <p className="publisher-name">{mission.assignedUserName}</p>
              <p className="publisher-title">{mission.assignedUserTitle}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMission;
